// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import {
    BREAKPOINTS,
    down,
} from 'common/styles/breakpoints';

export const HaStatusContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const IconContainer = styled.div`
    margin-right: 8px;

    svg {
        width: 16px;
        height: 16px;
    }

    ${down(BREAKPOINTS.LG)} {
        margin-right: 0;
        cursor: pointer;
    }
`;

export const HaStatusLabelContainer = styled.div`
    font-size: 14px;
    line-height: 20px;

    ${down(BREAKPOINTS.LG)} {
        display: none;
    }
`;
